import { Component, Input, computed } from '@angular/core';

import { getInitials, getAvatarColor } from '../../utils/color.utils';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

/**
 * Displays a user's initials in a colored circle; derives color deterministically from the name.
 */
@Component({
  selector: 'es-avatar',
  template: `
    <div
      [class]="classes()"
      [style.background]="background()"
      [style.border-color]="borderColor"
    >
      {{ initials() }}
    </div>
  `,
})
export class AvatarComponent {
  @Input({ required: true }) name!: string;
  @Input() size: AvatarSize = 'md';
  @Input() borderColor: string | null = null;

  initials = computed(() => getInitials(this.name));
  background = computed(() => {
    const color = getAvatarColor(this.name);
    return `linear-gradient(135deg, ${color}, ${color}88)`;
  });

  classes = computed(() => {
    const base = 'rounded-full flex items-center justify-center text-white font-semibold shrink-0';
    const sizes: Record<AvatarSize, string> = {
      sm: 'w-[22px] h-[22px] text-[9px]',
      md: 'w-[28px] h-[28px] text-[11px]',
      lg: 'w-9 h-9 text-sm',
      xl: 'w-16 h-16 text-2xl',
    };
    const border = this.borderColor ? 'border-2' : '';
    return `${base} ${sizes[this.size]} ${border}`;
  });
}
